export enum MeasurePackageType {
  Size = 'Size',
  DeterminingGirth = 'DeterminingGirth',
  ShortestLongestSize = 'ShortestLongestSize',
}
